// Tyler.API.Common.Interfaces.DetailType
export enum DetailType {
    None = 0,
    Custom = 1,
    Table = 2
}
